import { ChangeEvent } from 'react';

export const acceptNumeric =
    (cb: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void) => (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
        new RegExp('^[0-9]*$').test(e.currentTarget.value) && cb(e);

export const checkFileAccept = (accept: string, file: File): boolean => {
    const mimeMap: Record<string, string> = {
        '.jpg': 'image/jpeg',
        '.jpeg': 'image/jpeg',
        '.png': 'image/png'
    };

    const acceptArray = accept.split(',').map(ext => ext.trim());
    const fileType = file.type;

    return acceptArray.some(ext => mimeMap[ext] === fileType);
};
